"use strict";
(self["webpackChunkdev"] = self["webpackChunkdev"] || []).push([[5657],{

/***/ 5657:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ inlineToggle)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


/**
 * * Toggles a specified 'active' class on a given element on click
 *
 * @options
 * [data-toggle] {required} - Pass selector for target element
 */

function inlineToggle({ wrapper }) {
  // TODO: Organize & sync naming convention
  const selectors = {
    target: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('toggle'),
    triggers: `[data-toggle="${jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('toggle')}"]`,
    popup: '[data-is-popup]',
    expandable: '[data-is-expandable]',
    hideOverlay: '[data-hide-overlay]',
    closeOnBlur: '[data-close-on-blur]',
    triggerOnHover: '[data-use-hover]',
    hideOnMouseout: '[data-hide-mouseout]',
    toggleGroupParent: '[data-is-toggle-group]',
    toggleSiblings: '[data-toggle]',
  }

  const cache = {
    $targets: jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.target),
    $triggers: jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.triggers),
    $toggleGroupParent: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).parents(selectors.toggleGroupParent),
  }

  // TODO: Add comments / clearer variable names
  // remove double config / window.config
  const config = {
    isPopup: cache.$targets.is(selectors.popup),
    isExpandable: cache.$targets.is(selectors.expandable),
    hideOverlay: cache.$targets.is(selectors.hideOverlay),
    shouldCloseOnBlur: cache.$targets.is(selectors.closeOnBlur),
    shouldTriggerOnHover: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).is(selectors.triggerOnHover),
    shouldHideOnMouseout: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).is(selectors.hideOnMouseout),
    isToggleGroup: !!cache.$toggleGroupParent.length,
  }

  // TailwindCSS variants representing different states
  const { classes } = window.config

  const state = {
    mouseIsWithinRelatedElements: false,
  }

    ; (function initEventListeners() {
      if (config.shouldTriggerOnHover) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('mouseenter focus click', openOnHover)
      } else {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).off('click.inlineToggle.toggleProperties').on('click.inlineToggle.toggleProperties', toggleProperties)
      }

      if (config.shouldHideOnMouseout) {
        cache.$targets.on('mouseleave', closeOnMouseleave)
        cache.$triggers.on('mouseleave', closeOnMouseleave)

        cache.$targets.on('mouseenter', function (event) {
          state.mouseIsWithinRelatedElements = true
        })

        cache.$triggers.on('mouseenter', function (event) {
          state.mouseIsWithinRelatedElements = true
        })
      }

      if (config.isPopup) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('popup:close', closePopup)
      }

      if (config.shouldCloseOnBlur) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', closeOnBlur)
      }

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('toggle:close', close)
    })()

  function openOnHover() {
    const isActive = false

    cache.$targets.addClass(classes.active)
    cache.$triggers.addClass(classes.active)

    togglePopup(isActive)
    toggleExpandAttr(isActive)
    closeGroupSiblings()
  }

  function closeOnMouseleave(event) {
    const isActive = true
    const isWithinTrigger = !!jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.relatedTarget).closest(wrapper).length
    const isWithinTarget = !!jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.relatedTarget).closest(selectors.target).length

    state.mouseIsWithinRelatedElements = isWithinTrigger && isWithinTarget

    setTimeout(() => {
      if (!state.mouseIsWithinRelatedElements) {
        if (config.isPopup) {
          togglePopup(isActive)
        }
        close()
      }
    }, 300)
  }

  function togglePopup(isActive) {
    if (config.isPopup) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).trigger('popup:close')

      if (!isActive) {
        cache.$targets.trigger('popup:open')
      }

      toggleOverlay({ show: !isActive })
    }
  }

  function toggleExpandAttr(isActive) {
    if (config.isExpandable || config.isPopup) {
      cache.$triggers.attr('aria-expanded', !isActive)
    }
  }

  function closeGroupSiblings() {
    if (config.isToggleGroup) {
      const $groupSiblings = cache.$toggleGroupParent
        .find(selectors.toggleSiblings)
        .not(cache.$triggers)
        .filter(`.${classes.active}`)
      $groupSiblings.trigger('toggle:close')
    }
  }

  function toggleProperties() {
    const isActive = cache.$targets.hasClass(classes.active)

    cache.$targets.toggleClass(classes.active, !isActive)
    cache.$triggers.toggleClass(classes.active, !isActive)

    togglePopup(isActive)
    toggleExpandAttr(isActive)
    closeGroupSiblings()
  }

  function toggleOverlay({ show }) {
    if (show && !config.hideOverlay) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('overlay:show')
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('overlay:hide')
    }
  }

  function close() {
    cache.$targets.removeClass(classes.active)
    cache.$triggers.removeClass(classes.active)
  }

  function closePopup(event) {
    const eventTargetSelector = jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target).data('toggle')
    if (eventTargetSelector == selectors.target) return

    close()
  }

  function closeOnBlur(event) {
    const clickIsOutsideTrigger = !jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target).closest(selectors.triggers).length
    const clickIsOutsideTarget = !jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target).closest(selectors.target).length

    if (clickIsOutsideTrigger && clickIsOutsideTarget) {
      close()
    }
  }
}

/***/ })

}]);